import React from "react";
import { Form } from "react-bootstrap";

export default function AddAccessTab() {
  return (
    <>
      <Form.Check type="switch" label="Allow Access" />
      <Form.Check type="switch" label="Enable Notifications" />
    </>
  );
}